<template>
  <ZubieDialog no-caps ok-only>
    <template #title>
      <div class="line-height-1">
        <div>{{ title }}</div>
        <div class="text-caption">Sent at {{ createdTime }} on {{ createdDate }}</div>
      </div>
    </template>
    <div class="text-center text-h5">“{{ body }}”</div>
  </ZubieDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { dayjs } from 'src/services/date';

const props = defineProps<{ created: string; body: string; title: string }>();

const created = dayjs.utc(props.created).local();

const createdTime = computed(() => created.format('h:m:ss A'));

const createdDate = computed(() => created.format('M/D/YYYY'));
</script>
